import * as Network from 'expo-network';

export async function hasInternet(): Promise<boolean> {
    const { isInternetReachable }: Network.NetworkState = await Network.getNetworkStateAsync();
    return isInternetReachable ? true : false;
}